import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MobileDeviceService } from '@app/services/mobile-device.service';

import { GalleryDestination } from '@ux/components/gallery-destination/entities/gallery-destination';
import { Store } from '@shared/sliders/entities/slide-models';

@Pipe({
  name: 'imageDesktopOrMobile',
  standalone: false
})
export class ImageDesktopOrMobilePipe implements PipeTransform {

  constructor(private mobileDeviceService: MobileDeviceService) {}

  transform(image: GalleryDestination | Store): Observable<string> {
    return this.mobileDeviceService.isMobileDevice$.pipe(
      map((isMobileDevice) => 
        isMobileDevice ? image.image_url 
          : image.desktop_image_url
            ? image.desktop_image_url : image.image_url
      )
    );
  }
}
